export default __webpack_public_path__ + "static/step-selezione-astrorei-5141ecc76e2b442b46cbdd4d3a544017.jpg";